import React from 'react';

export default function UnitCard({ unit, status, onPlay }) {
  // Map status to appropriate styles
  const statusStyles = {
    completed: {
      border: "border-2 border-green-500",
      bg: "bg-green-50",
      text: "text-green-700",
      icon: "text-green-500"
    },
    inProgress: {
      border: "border-2 border-blue-500",
      bg: "bg-blue-50",
      text: "text-blue-700",
      icon: "text-blue-500"
    },
    unlocked: {
      border: "border-2 border-gray-300",
      bg: "bg-white",
      text: "text-gray-800",
      icon: "text-gray-600"
    },
    locked: {
      border: "border-2 border-dashed border-gray-300",
      bg: "bg-gray-50",
      text: "text-gray-400",
      icon: "text-gray-400"
    }
  };
  
  const style = statusStyles[status] || statusStyles.locked;
  
  return (
    <div 
      className={`w-32 h-32 rounded-xl ${style.border} ${style.bg} flex flex-col items-center justify-center cursor-pointer transition-all duration-200 hover:shadow-md transform hover:scale-105 ${status === "locked" ? "cursor-not-allowed" : "cursor-pointer"}`}
      onClick={status === "locked" ? null : onPlay}
    >
      <div className={`text-4xl mb-2 ${style.icon}`}>{unit.icon}</div>
      <div className={`text-sm text-center px-2 ${style.text}`}>{unit.title}</div>
      
      {/* Status indicator */}
      <div className="mt-2">
        {status === "completed" && (
          <span className="inline-block w-4 h-4 bg-green-500 rounded-full" title="Completed"></span>
        )}
        {status === "inProgress" && (
          <span className="inline-block w-4 h-4 bg-blue-500 rounded-full" title="In Progress"></span>
        )}
      </div>
    </div>
  );
}
